import config from '../config/server-config';
import { API_CALL_SUCCESSFULL } from '../constants/NumberConstants';
import { ACTIVISM } from '../constants/ProductConstants';
import moment from 'moment';
import api from '../api';

const DEFAULT_YEARS_BACK = 5;

export const NOTIFIED_HOLDINGS_SOURCE_OPTIONS = [
  { label: 'Notified', value: 'Notified' },
  { label: '13D', value: '13d' },
  { label: '13F', value: '13f' },
];
export const NOTIFIED_HOLDINGS_STATUS_OPTIONS = [
  { label: 'All', value: 'All' },
  { label: 'Current', value: 'Current' },
  { label: 'Exited', value: 'Exited' },
];
export const NOTIFIED_HOLDINGS_MOST_RECENT_OPTIONS = [
  { label: 'All', value: 'All' },
  { label: 'Yes', value: 'Yes' },
  { label: 'No', value: 'No' },
];

export const toIsoDate = (date) => {
  if (!date) return null;
  const m = date instanceof Date ? moment(date) : moment(String(date), 'YYYY-MM-DD', true);
  return m.isValid() ? m.format('YYYY-MM-DD') : null;
};

export const getDefaultNotifiedHoldingsFilters = (today = new Date()) => ({
  dateFrom: moment(today).subtract(DEFAULT_YEARS_BACK, 'years').format('YYYY-MM-DD'),
  dateTo: moment(today).format('YYYY-MM-DD'),
  sources: [],
  sharesHeldMin: null,
  sharesHeldMax: null,
  pcentHeldMin: null,
  pcentHeldMax: null,
  holdingStatus: 'Current',
  mostRecent: 'All',
});

const toNumberOrNull = (value) =>
  value === null || value === undefined || value === '' || Number.isNaN(Number(value)) ? null : Number(value);

const allToNull = (value) => (!value || value === 'All' ? null : value);

export const buildNotifiedHoldingsFilterParams = (filters) => ({
  date_notified_from: filters.dateFrom || null,
  date_notified_to: filters.dateTo || null,
  sources: filters.sources && filters.sources.length > 0 ? filters.sources : null,
  shares_held_min: toNumberOrNull(filters.sharesHeldMin),
  shares_held_max: toNumberOrNull(filters.sharesHeldMax),
  pcent_held_min: toNumberOrNull(filters.pcentHeldMin),
  pcent_held_max: toNumberOrNull(filters.pcentHeldMax),
  holding_status: allToNull(filters.holdingStatus),
  most_recent: allToNull(filters.mostRecent),
});

const isOrdered = (from, to) => from === null || to === null || from <= to;

export const isNotifiedHoldingsFilterRangeValid = (filters) =>
  isOrdered(filters.dateFrom || null, filters.dateTo || null) &&
  isOrdered(toNumberOrNull(filters.sharesHeldMin), toNumberOrNull(filters.sharesHeldMax)) &&
  isOrdered(toNumberOrNull(filters.pcentHeldMin), toNumberOrNull(filters.pcentHeldMax));

export const getNotifiedHoldingsRowLimitMessage = (totalRows, maxRows) =>
  maxRows && totalRows > maxRows
    ? `*Please note, this dataset is limited to the top ${Number(maxRows).toLocaleString('en-US')}`
    : '';

export const GetActivismNotifiedHoldingsToolList = async (req) => {
  try {
    const token = localStorage.getItem('token');
    const response = await api.post(
      config.getActivismNotifiedHoldingsToolData,
      {
        product_id: ACTIVISM,
        token,
        company_search_id: req.company_search_id ?? null,
        investor_search_id: req.investor_search_id ?? null,
        ...buildNotifiedHoldingsFilterParams(req.filters ?? {}),
      },
      {
        cancelToken: req.cancelToken,
      },
    );
    if (response.status === API_CALL_SUCCESSFULL) {
      return response.data;
    }
  } catch (e) {
    if (e?.name === 'AbortError') return null;
    return false;
  }
  return false;
};

export default { GetActivismNotifiedHoldingsToolList };
